// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer-bgImageSection-Jaji6 {
	position: relative;
	height: auto;
	min-height: 300px;
	padding-top: 42px;
}

/* .bgImage {
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: cover;
	padding-top: 8%;
	margin-top: 80px;
} */

.Footer-bgColor-MvASW {
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: cover;
	background-color: var(--common-gray-bg-color);
	position: absolute;
	left: 0px;
	right: 0px;
	top: 0px;
}

.Footer-bgWhite-DvBmu {
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: cover;
	position: absolute;
	left: 0px;
	right: 0px;
	top: 0px;
	background-color: var(--primary-white-bg);
}

.Footer-container-HxA6p {
	margin: 0 auto;
	max-width: var(--max-content-width);
	padding: 0px 68px 0px;
}

.Footer-shareIcon-kQNHG {
	cursor: pointer;
	width: 100%;
	max-width: 40px;
	border-radius: 50%;
	border: 1px solid var(--primary-border);
	padding: 7px;
	text-align: center;
}

.Footer-shareIcon-kQNHG:hover img {
	-webkit-filter: invert(20%) sepia(100%) saturate(2054%) hue-rotate(214deg) brightness(103%) contrast(97%);
	        filter: invert(20%) sepia(100%) saturate(2054%) hue-rotate(214deg) brightness(103%) contrast(97%);
}

.Footer-listContainer-coPwN {
	padding: 0px;
	list-style-type: none;
	margin-bottom: 0;
}

.Footer-socialFlex-R89PO {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.Footer-displayFlex-uGMeM {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	margin-bottom: 12px;
}

.Footer-displayGrid-rvHGC {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
}

.Footer-twitterMargin-h_WrS {
	margin: 0px 12px 0px 12px;
}

.Footer-appStoreMargin-Joprx {
	margin-right: 23px;
}

.Footer-searchFooterWaveBg-kfPn7 {
	padding-top: 30px;
	margin-top: 0;
	background: var(--common-gray-bg-color);
	border-top: 1px solid var(--primary-border);
}

.Footer-footerContainer-Cc66z {
	margin-top: 60px;
}

@media screen and (max-width: 1199px) and (min-width: 768px) {
	.Footer-container-HxA6p {
		padding: 0px 30px 0px;
	}
}

@media screen and (max-width: 767px) {
	.Footer-container-HxA6p {
		padding: 0px 15px;
	}

	.Footer-displayGrid-rvHGC {
		grid-template-columns: repeat(1, minmax(0, 1fr));
	}

	.Footer-flexReverse-WE433 {
		-webkit-box-orient: vertical;
		-webkit-box-direction: reverse;
		    -ms-flex-direction: column-reverse;
		        flex-direction: column-reverse;
	}

	.Footer-appStoreMargin-Joprx {
		margin-right: 4px;
	}

	.Footer-siteNamePadding-f8LPj {
		padding: 20px;
	}

	.Footer-searchFooterWaveBg-kfPn7 {
		padding-top: 0;
		margin-top: 0;
	}

	.Footer-bgImageSection-Jaji6 {
		padding-top: 24px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;;;;;;;;GAQG;;AAEH;CACC,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,4BAA4B;CAC5B,sBAAsB;CACtB,6CAA6C;CAC7C,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,QAAQ;AACT;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,4BAA4B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,QAAQ;CACR,yCAAyC;AAC1C;;AAEA;CACC,cAAc;CACd,mCAAmC;CACnC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,uCAAuC;CACvC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,yGAAiG;SAAjG,iGAAiG;AAClG;;AAEA;CACC,YAAY;CACZ,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gDAAgD;AACjD;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,uCAAuC;CACvC,2CAA2C;AAC5C;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,iBAAiB;CAClB;;CAEA;EACC,gDAAgD;CACjD;;CAEA;EACC,4BAA8B;EAA9B,8BAA8B;MAA9B,kCAA8B;UAA9B,8BAA8B;CAC/B;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,cAAc;EACd,aAAa;CACd;;CAEA;EACC,iBAAiB;CAClB;AACD","sourcesContent":[".bgImageSection {\n\tposition: relative;\n\theight: auto;\n\tmin-height: 300px;\n\tpadding-top: 42px;\n}\n\n/* .bgImage {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tbackground-size: cover;\n\tpadding-top: 8%;\n\tmargin-top: 80px;\n} */\n\n.bgColor {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tbackground-size: cover;\n\tbackground-color: var(--common-gray-bg-color);\n\tposition: absolute;\n\tleft: 0px;\n\tright: 0px;\n\ttop: 0px;\n}\n\n.bgWhite {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tbackground-size: cover;\n\tposition: absolute;\n\tleft: 0px;\n\tright: 0px;\n\ttop: 0px;\n\tbackground-color: var(--primary-white-bg);\n}\n\n.container {\n\tmargin: 0 auto;\n\tmax-width: var(--max-content-width);\n\tpadding: 0px 68px 0px;\n}\n\n.shareIcon {\n\tcursor: pointer;\n\twidth: 100%;\n\tmax-width: 40px;\n\tborder-radius: 50%;\n\tborder: 1px solid var(--primary-border);\n\tpadding: 7px;\n\ttext-align: center;\n}\n\n.shareIcon:hover img {\n\tfilter: invert(20%) sepia(100%) saturate(2054%) hue-rotate(214deg) brightness(103%) contrast(97%);\n}\n\n.listContainer {\n\tpadding: 0px;\n\tlist-style-type: none;\n\tmargin-bottom: 0;\n}\n\n.socialFlex {\n\tdisplay: flex;\n}\n\n.displayFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 12px;\n}\n\n.displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.twitterMargin {\n\tmargin: 0px 12px 0px 12px;\n}\n\n.appStoreMargin {\n\tmargin-right: 23px;\n}\n\n.searchFooterWaveBg {\n\tpadding-top: 30px;\n\tmargin-top: 0;\n\tbackground: var(--common-gray-bg-color);\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.footerContainer {\n\tmargin-top: 60px;\n}\n\n@media screen and (max-width: 1199px) and (min-width: 768px) {\n\t.container {\n\t\tpadding: 0px 30px 0px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.container {\n\t\tpadding: 0px 15px;\n\t}\n\n\t.displayGrid {\n\t\tgrid-template-columns: repeat(1, minmax(0, 1fr));\n\t}\n\n\t.flexReverse {\n\t\tflex-direction: column-reverse;\n\t}\n\n\t.appStoreMargin {\n\t\tmargin-right: 4px;\n\t}\n\n\t.siteNamePadding {\n\t\tpadding: 20px;\n\t}\n\n\t.searchFooterWaveBg {\n\t\tpadding-top: 0;\n\t\tmargin-top: 0;\n\t}\n\n\t.bgImageSection {\n\t\tpadding-top: 24px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bgImageSection": `Footer-bgImageSection-Jaji6`,
	"bgColor": `Footer-bgColor-MvASW`,
	"bgWhite": `Footer-bgWhite-DvBmu`,
	"container": `Footer-container-HxA6p`,
	"shareIcon": `Footer-shareIcon-kQNHG`,
	"listContainer": `Footer-listContainer-coPwN`,
	"socialFlex": `Footer-socialFlex-R89PO`,
	"displayFlex": `Footer-displayFlex-uGMeM`,
	"displayGrid": `Footer-displayGrid-rvHGC`,
	"twitterMargin": `Footer-twitterMargin-h_WrS`,
	"appStoreMargin": `Footer-appStoreMargin-Joprx`,
	"searchFooterWaveBg": `Footer-searchFooterWaveBg-kfPn7`,
	"footerContainer": `Footer-footerContainer-Cc66z`,
	"flexReverse": `Footer-flexReverse-WE433`,
	"siteNamePadding": `Footer-siteNamePadding-f8LPj`
};
module.exports = ___CSS_LOADER_EXPORT___;
